import { Logo } from '@bp/ui-components';
import classNames from 'classnames';
import { BpCard } from 'components/BpCard/BpCard';
import type { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PageLayoutPlaceholder.module.scss';

interface PageLayoutPlaceholderProps extends PropsWithChildren<{ alignCenter?: boolean }> {
  alignCenter?: boolean;
}

export const PageLayoutPlaceholder: FC<PageLayoutPlaceholderProps> = ({ alignCenter, children }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['page-layout-placeholder']} data-cy='layoutWrapper'>
      <BpCard className={styles.content} preventCollapsible disableCollapsible>
        <div className={styles.header}>
          <Logo className={styles.logo} type={'bildungsplattform'} collapsed={false} />
          <div className={styles.claim}>{t('app.claim')}</div>
        </div>
        <div
          className={classNames(styles.children, {
            [styles['align-center']]: alignCenter,
          })}
        >
          {children}
        </div>
      </BpCard>
      <div className={styles.footer}>
        <a href='https://bildungsplattform.org/impressum/' target={'_blank'} rel='noreferrer'>
          {t('about.imprint')}
        </a>
        <div className={styles.divider}></div>
        <a href='https://www.tk-schulsoftware.de/datenschutz/' target={'_blank'} rel='noreferrer'>
          {t('about.privacy')}
        </a>
        <div className={styles.divider}></div>
        <a href='https://bildungsplattform.org/nutzungsbedingungen/' target={'_blank'} rel='noreferrer'>
          {t('about.tos')}
        </a>
        <div className={styles.divider}></div>
        <a href='https://www.tk-schulsoftware.de/netzwerk/' target={'_blank'} rel='noreferrer'>
          {t('about.partner')}
        </a>
      </div>
    </div>
  );
};
